<template>
  <div class="wrapper">
    <template v-if="noSerial">
       <h2>Welcome to the Kotobee App</h2>
       <p>
          You do not have a serial number stored yet. Please go to <a href @click.prevent="$router.push('settings')">Settings</a> and enter your Kotobee serial number there.
       </p>
    </template>
    <template v-else>
        <h2>Currently Linked Products</h2>
        <p v-if="!summary.length">
            There are currently no products in your store. You will need to start adding your ebook products (from the Products section). For instructions please refer to this <a href="https://support.kotobee.com/en/support/solutions/articles/8000079831-integrate-with-shopify" target="_blank">support article</a>.
        </p>
        <div v-else>
            <p>
                Below is a list of all your store products. You will need to link the ebook products to Kotobee so that your users receive access once they make a purchase.
            </p>
            <table>
                <tr>
                    <th>Shopify Product</th>
                    <th>Linked Kotobee Resources</th>
                </tr>
                <tr v-for="product in summary" :key="product.id">
                    <td>{{ product.title }}</td>
                    <td>        
                    <product-summary :access-list="product.access" />
                    </td>
                </tr>
            </table>
        </div>
        <div v-show="hasMore" class="loadMore">
            <b-button  variant="outline-primary" @click="loadMore">Load More</b-button>
        </div>
        <div>
            <b-button variant="primary" @click="$router.push('linking')">Go to Linking Page</b-button>
        </div>
    </template>
  </div>
</template>

<script>
import ProductSummary from '../elements/ProductSummary.vue'
import {BButton} from "bootstrap-vue";

export default {
  name: 'SummaryPage',
  props: {
    title: String,
  },
  components: {
    BButton,
    ProductSummary
  },
  data() {
    return {
      noSerial: null,
      products: function() {
        return [];
      },
    }
  },
  mounted: function() {
    var $scope = this;
    this.$store.dispatch('fetchShopifySettings', function(settings){
        $scope.noSerial = !settings.serial;
        if(settings.serial) {
            $scope.$store.dispatch('loadProductAccessList');
            $scope.$store.dispatch('fetchKotobeeResources');
        }
    });
  },
  methods: {
    loadMore() {
      this.$store.dispatch('loadProductAccessList', {append: true});
    }
  },
  computed: {
    summary() {
      return this.$store.state.productAccess;
    },
    hasMore() {
      return this.$store.state.lastCursor != null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loadMore {
  text-align: center;
  margin: 20px 0;
}
.wrapper {
  width: 100%;
  text-align: center;
}
table {
  width: 100%;
  text-align: center;
  table-layout: fixed;
    max-width: 500px;
    margin: 20px auto;
    margin-bottom: 30px;
}
tr:nth-child(even) {
  background: #DDD
}
p {
    text-align: left;
}
h2 {
  margin: 20px 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
